import React from 'react';
import { Card, CardContent } from '../ui/card';
import { cn } from '../../lib/utils';

/**
 * StatCard — KPI tile for dashboards.
 *
 *   <StatCard
 *     icon={<Ticket />}
 *     label="Tickets vendidos"
 *     value="1,284"
 *     delta={{ direction: 'up', value: '+12.4%' }}
 *     loading={false}
 *   />
 */
export default function StatCard({
  icon,
  label,
  value,
  delta,
  helpText,
  loading = false,
  className,
}) {
  const deltaColor =
    delta?.direction === 'up'
      ? 'text-success'
      : delta?.direction === 'down'
        ? 'text-destructive'
        : 'text-muted-foreground';

  return (
    <Card className={className}>
      <CardContent className='p-5 pt-5'>
        <div className='flex items-center gap-3'>
          {icon && (
            <div className='flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary'>
              <span className='h-5 w-5'>{icon}</span>
            </div>
          )}
          <span className='text-sm font-medium text-muted-foreground'>{label}</span>
        </div>

        <div className='mt-3 flex items-baseline gap-2'>
          {loading ? (
            <div className='h-8 w-24 animate-pulse rounded bg-muted motion-reduce:animate-none' />
          ) : (
            <span className='min-w-0 break-words text-3xl font-semibold tracking-tight text-foreground'>
              {value}
            </span>
          )}
          {delta && !loading && (
            <span className={cn('text-sm font-medium', deltaColor)}>{delta.value}</span>
          )}
        </div>

        {helpText && <p className='mt-1 text-xs text-muted-foreground'>{helpText}</p>}
      </CardContent>
    </Card>
  );
}
